import 'stylesheets/pages/scoutees/index/scoutees_index';
import LikeUserButton from 'modules/LikeUserButton';
import PopupWithProfile from 'modules/PopupWithProfile';
import ScouteeFormFile from 'modules/ScouteeFormFile';
import SelectScoutMessage from 'modules/SelectScoutMessage';

new SelectScoutMessage();
new PopupWithProfile();
new ScouteeFormFile();

const likeUserButtonTargets = Array.from(document.querySelectorAll('.vue-like-user-button'));
likeUserButtonTargets.forEach((el) => {
  new LikeUserButton(el);
});
